module.exports = __webpack_public_path__ + "img/yhlDesc.97984999.svg";